import { render } from "./AContact.vue?vue&type=template&id=f757edfa&scoped=true"
import script from "./AContact.vue?vue&type=script&lang=js"
export * from "./AContact.vue?vue&type=script&lang=js"

import "./AContact.vue?vue&type=style&index=0&id=f757edfa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f757edfa"]])

export default __exports__